<mat-card class="message1" [ngClass]="{small: _isSmall}" *ngIf="view == 'message1'">
  <div class="message">
    Usamos cookies e outras tecnologias semelhantes para armazenar informações sobre como você usa o nosso site.
    Tudo para tornar sua experiência a mais agradável possível.<br>
    Ao clicar em 'ACEITO', você consente com a utilização de cookies.<br>
    Para mais informações conheça nossa <span class="link" (click)="showPrivacy()">Política de privacidade</span>

  </div>
  <div class="action">
    <button mat-button (click)="accept()">ACEITO</button>
  </div>
</mat-card>
